import React from 'react'
import { Button } from 'antd'
import { useIntl } from 'react-intl'
import { SendOutlined } from '@ant-design/icons'

function Send({
  icon = <SendOutlined />,
  type = 'success',
  title = 'button.send',
  onClick = () => {},
  id = 'btn-send',
  ...props
}) {
  const { formatMessage } = useIntl()
  const buttonTitle = title === 'button.send' ? formatMessage({ id: title }) : title

  return (
    <Button
      {...props}
      disabled={props.disabled || props.loading}
      title={buttonTitle}
      onClick={onClick}
      icon={icon}
      type={type}
      id={id}
    >
      {buttonTitle}
    </Button>
  )
}

export default Send
